module.exports = __webpack_public_path__ + "img/arrowRoundBack.15602cef.svg";